/*
Important
This file is used only for the vue2 application.
Changes made here will not be reflected in the Vue3 application.
You need to make changes in the vue3 file also
Vue3 file: Velocity.PrimaryOffersites.Web\wwwroot\vue3\src\store\PaymentSettings\PaymentsettingsStore.js
Any clarifications contact Leela Directly
*/

import * as actiontypes from '../types';
import * as constants from '../../js/constants/constants';
import { Payments } from '../../js/services/Payments/Payments';
import { adminDefaultPaymentSelectionSettings } from '../../js/services/Payments/PaymentsService';
import axios from 'axios';
import { PAYMENT_CONFIGURATION_DETAILS } from '../../js/constants/expresspaymentconstants';
import ShiftDigitalContainer from '../../js/services/ShiftDigital/ShiftDigitalContainer';
import { SmartPathService } from '../../js/services/SmartPath/SmartPathService';
export const PaymentSettings = {
  state: {
    runBuggySettings: {
      enableRunBuggyIntegration: false,
      placement: '',
      paymentTypes: '',
      inventoryTypes: '',
    },
    deliveryType: {
      lease: {},
      cash: {},
      finance: {},
    },
    settings: {},
    feesData: {
      totalFeeUsed: 0,
      totalFeeNew: 0,
    },
    showPreQualModel: false,
    shiftDigitalDone: false,
    paymentsFeesData: '',
    expressPaymentsFeesData: '',
    isVehicleDetailsPage: false,
    completePaymentsData: '',
    showTransactPopup: false,
    interestedComponentType: '',
    showTransactPopupIframe: false,
    settingssuccess: false,
    vdpContactFromTransact: false,
    vdpContactFromPaymentPanel: false,
    showVdpContactUS: false,
    showTextMeQuote: false,
    showRequestVideo: false,
    showDownPaymentMessage: false,
    vdpContactUsZindex: false,
    unlockEPriceCookie: true,
    unlockEPriceCookieVin: true,
    unlockCashPriceDiscount: true,
    transactUnlockFormModal: true,
    showOverLayPaymentsData: '',
    cashTradeValue: 0,
    cashPriceDiscountValue: 0,
    selectedPaymentOption: constants.LEASE,
    miles: [],
    leasedata: '',
    totalLeaseData: '',
    leaseTerms: [],
    financeTerms: [],
    gotpayments: false,
    financedata: '',
    showLoading: false,
    showLeaseTab: false,
    showFinanceTab: false,
    pageStateKey: '',
    paymentConfiguration: PAYMENT_CONFIGURATION_DETAILS,
    previousSelectedValues: {
      lease: {
        selectedPayment: '',
        mileage: '',
        downPayment: '',
        tradeValue: '',
        term: '',
      },
      finance: {
        selectedPayment: '',
        mileage: '',
        downPayment: '',
        tradeValue: '',
        term: '',
      },
    },
    interestedActiveComponent: '',
    ctaActiveComponent: '',
    lockInPaymentType: '',
    ctaActiveComponentProps: {},
    formHeading: '',
    formButtonLabel: '',
    formActionName: '',
    formButtonColor: '',
    formButtonFontColor: '',
    isTransact: false,
    smartPathUnlockStatus: '',
    fordDirectQualifiedIncentives: {},
    conditionalRebateIncentives: {},
    rebateLabel: '',
    discountLabel: '',
    finalPriceLabel: '',
    smartpathDealerDisclaimer: '',
    smartpathDDOADisclaimer: '',
    softPullVehiclePrice: 0,
    getSoftPullSettings: {},
    feesResults: '',
    aisRebates: {},
    standardFinanceVehicleData: {},
    paymentCalculatorInteractionCount: 0,
    sendToPhoneVdv: false,
    vdpPrintPriceDetails: '',
    vdpPrintCfp: '',
    alternatePayments: {
      rebates: {
        label: '',
        value: '',
      },
      fee: {
        label: '',
        value: '',
      },
      tax: {
        label: '',
        value: '',
      },
    },
    unlockCtaDiscountData: {},
  },
  getters: {
    [actiontypes.FORMAT_RUN_BUGGY_RESPONSE]: (state, payload) => {
      let inventoryType = window.inventoryType.toLowerCase();
      let selectedPaymentOption = state.selectedPaymentOption.toLowerCase();

      return {
        placement: {
          vdp: state.runBuggySettings.placement.includes('vdp'),
          transact: state.runBuggySettings.placement.includes('transact'),
        },
        inventoryTypes: {
          new: state.runBuggySettings.inventoryTypes.includes('new') && inventoryType === 'new',
          used: state.runBuggySettings.inventoryTypes.includes('used') && inventoryType === 'used',
          cpo: state.runBuggySettings.inventoryTypes.includes('cpo') && inventoryType === 'cpo',
        },
        paymentTypes: {
          lease:
            state.runBuggySettings.paymentTypes.includes('lease') &&
            selectedPaymentOption === 'lease',
          finance:
            state.runBuggySettings.paymentTypes.includes('finance') &&
            selectedPaymentOption === 'finance',
          cash:
            state.runBuggySettings.paymentTypes.includes('cash') &&
            selectedPaymentOption === 'cash',
        },
      };
    },
    [actiontypes.GET_SELECTED_PAYMENT_DATA]: (state, payload) => {
      if (state.selectedPaymentOption.toLowerCase() === constants.LEASE.toLowerCase()) {
        return state.leasedata;
      }

      if (state.selectedPaymentOption.toLowerCase() === constants.FINANCE.toLowerCase()) {
        return state.financedata;
      }

      return '';
    },
    [actiontypes.GET_UNLOCK_PRICE_COOKIE]: (state, payload) => {
      if (state.unlockEPriceCookie || state.showOverLayPaymentsData) {
        if (
          state.showOverLayPaymentsData.enableOverleyOnVDP ||
          state.showOverLayPaymentsData.enableOverleyOnTransact
        ) {
          let cookieValue = '';
          let cookie = document.cookie.indexOf('unLockPriceCookie') >= 0;
          if (cookie) {
            let cookieName = 'unLockPriceCookie';
            let name = cookieName + '=';
            let decodedCookie = decodeURIComponent(document.cookie);
            let cookieList = decodedCookie.split(';');
            for (let c of cookieList) {
              while (c.startsWith(' ')) {
                c = c.substring(1);
              }
              if (c.startsWith(name)) {
                cookieValue = c.substring(name.length, c.length);
              }
            }
            if (cookieValue.trim() === window.tid.trim()) {
              state.unlockEPriceCookie = false;
              return false;
            } else {
              state.unlockEPriceCookie = true;

              return true;
            }
          } else {
            state.unlockEPriceCookie = true;

            return true;
          }
        }
      } else {
        state.unlockEPriceCookie = false;

        return false;
      }
    },
    /* [actiontypes.GET_UNLOCK_PRICE_COOKIE_VIN]: (state, payload) => {
      if (state.unlockEPriceCookieVin || state.showOverLayPaymentsData) {
        if (
          state.showOverLayPaymentsData.enableOverleyOnVDP ||
          state.showOverLayPaymentsData.enableOverleyOnTransact
        ) {
          let cookieValue = '';
          let cookie = document.cookie.indexOf('unlockEPriceCookieVin') >= 0;
          if (cookie) {
            let cookieName = 'unlockEPriceCookieVin';
            let name = cookieName + '=';
            let decodedCookie = decodeURIComponent(document.cookie);
            let cookieList = decodedCookie.split(';');
            for (let i = 0; i < cookieList.length; i++) {
              let c = cookieList[i];
              while (c.charAt(0) == ' ') {
                c = c.substring(1);
              }
              if (c.indexOf(name) == 0) {
                cookieValue = c.substring(name.length, c.length);
              }
            }
            if (cookieValue.trim() === window.tid.trim()) {
              state.unlockEPriceCookieVin = false;
              return false;
            } else {
              state.unlockEPriceCookieVin = true;

              return true;
            }
          } else {
            state.unlockEPriceCookieVin = true;

            return true;
          }
        }
      } else {
        state.unlockEPriceCookieVin = false;

        return false;
      }
    },*/
    [actiontypes.GET_STANDARD_FINANCE_VEHICLE_DATA]: (state) => {
      if (state.selectedPaymentOption.toLowerCase() === constants.FINANCE.toLowerCase()) {
        return state.standardFinanceVehicleData?.Disclaimers;
      }

      return '';
    },
  },
  mutations: {
    [actiontypes.SET_RUN_BUGGY_SETTINGS](state, payload) {
      state.runBuggySettings = payload;
    },
    [actiontypes.RUN_BUGGY_DELIVERY_TYPE](state, payload) {
      state.deliveryType[payload.type.toLowerCase()] = payload.deliveryType;
    },
    setTotalLeaseData(state, payload) {
      state.totalLeaseData = payload;
    },
    setLeaseTerms(state, payload) {
      state.leaseTerms = payload;
    },
    setFinanceTerms(state, payload) {
      state.financeTerms = payload;
    },
    [actiontypes.SET_PAYMENT_FEES_RESULTS](state, payload) {
      state.feesResults = payload;
    },
    [actiontypes.SET_CUSTOM_FEES_DATA_MUTATIONS](state, payload) {
      state.feesData = payload;
    },
    [actiontypes.SET_SMARTPATH_DEALER_DISCLAIMER_SETTINGS](state, payload) {
      state.smartpathDealerDisclaimer = payload;
    },
    [actiontypes.SET_VDP_PRINT_DETAILS](state, payload) {
      state.vdpPrintPriceDetails = payload;
    },
    [actiontypes.SET_VDP_PRINT_CFP_DATA](state, payload) {
      state.vdpPrintCfp = payload;
    },
    [actiontypes.SET_SMARTPATH_DDOA_DISCLAIMER_SETTINGS](state, payload) {
      state.smartpathDDOADisclaimer = { ...state.smartpathDDOADisclaimer, ...payload };
    },
    setPaymentsFeesData(state, payload) {
      state.paymentsFeesData = payload;
    },
    setExpressPaymentsFeesData(state, payload) {
      state.expressPaymentsFeesData = payload;
    },
    getpaymentsettings(state, payload) {
      state.settings = payload;
    },
    getFordDirectQualifiedIncentives(state, payload) {
      state.fordDirectQualifiedIncentives = payload;
    },
    setConditionalRebateIncentives(state, payload) {
      state.conditionalRebateIncentives = payload;
    },
    getRebateLabel(state, payload) {
      state.rebateLabel = payload;
    },
    getDiscountLabel(state, payload) {
      state.discountLabel = payload;
    },
    getFinalPriceLabel(state, payload) {
      state.finalPriceLabel = payload;
    },
    setAisRebates(state, payload) {
      state.aisRebates = payload;
    },
    setVehicleDetailsPage(state, payload) {
      state.isVehicleDetailsPage = payload;
    },
    paymentsettingssuccess(state, payload) {
      state.settingssuccess = true;
    },
    getleasedata(state, payload) {
      state.leasedata = payload;
    },
    getfinancedata(state, payload) {
      state.financedata = payload;
    },
    setloading(state, payload) {
      state.showLoading = payload;
    },
    [actiontypes.PAYMENT_CALCULATOR_SHOW_MAX_DOWN_PAYMENT_MESSAGE](state, payload) {
      state.showDownPaymentMessage = payload;
    },
    [actiontypes.TRANSACT_POPUP_SHOW_TRANSACT](state, payload) {
      state.showTransactPopup = payload;
    },
    [actiontypes.TRANSACT_POPUP_SHOW_TRANSACT_IFRAME](state, payload) {
      state.showTransactPopupIframe = payload;
    },
    setpaymentsgot(state, payload) {
      state.gotpayments = payload;
    },

    [actiontypes.SET_FINANCE_DATA](state, payload) {
      state.financedata = payload;
    },
    [actiontypes.SET_LEASE_DATA](state, payload) {
      state.leasedata = payload;
    },

    [actiontypes.SET_MILES_DATA](state, payload) {
      let miles = [];

      for (let mile of payload.MileageAllowances) {
        miles.push(mile.Mileage);
      }
      state.miles = miles;
    },
    [actiontypes.SET_SELECTEDPAYMENTOPTION](state, payload) {
      state.selectedPaymentOption = payload;
    },
    [actiontypes.SET_LEASETAB](state, payload) {
      state.showLeaseTab = payload;
    },

    [actiontypes.SET_FINANCE_TAB](state, payload) {
      state.showFinanceTab = payload;
    },

    [actiontypes.SET_PAYMENT_CONFIGURATION_DATA](state, payload) {
      state.paymentConfiguration = {
        ...state.paymentConfiguration,
        ...payload,
      };
    },
    [actiontypes.SET_CASH_TRADE_VALUE](state, payload) {
      state.cashTradeValue = payload;
    },
    [actiontypes.SET_PAGESTATE_KEY](state, payload) {
      state.pageStateKey = payload;
    },
    [actiontypes.PAYMENT_SET_PREVIOUS_SELECTED_VALUES](state, payload) {
      state.previousSelectedValues[payload.type] = payload.values;
    },
    [actiontypes.PAYMENT_SET_INTERESTED_COMPONENT_NAME](state, payload) {
      state.interestedActiveComponent = payload;
    },

    [actiontypes.SET_INTERESTED_LEAD_TYPE](state, payload) {
      state.interestedComponentType = payload;
    },
    [actiontypes.PAYMENT_SET_CTA_ACTION_COMPONENT_NAME](state, payload) {
      state.ctaActiveComponent = payload;
    },
    [actiontypes.PAYMENT_SET_CTA_ACTION_COMPONENT_PROPS](state, payload) {
      state.ctaActiveComponentProps = payload;
    },
    [actiontypes.SET_PAYMENTS_OVERLAY_DATA](state, payload) {
      state.showOverLayPaymentsData = payload;
    },
    [actiontypes.SET_UNLOCK_PRICE_COOKIE](state, payload) {
      let cookieExpiryDate = new Date(new Date().getTime() + 30 * 24 * 60 * 60 * 1000);
      document.cookie = `unLockPriceCookie=${window.tid};path=/;expires=${cookieExpiryDate}`;
      state.unlockEPriceCookie = false;
    },
    [actiontypes.SET_UNLOCK_PRICE_COOKIE_VIN](state, payload) {
      let cookieExpiryDate = new Date(new Date().getTime() + 30 * 24 * 60 * 60 * 1000);
      payload = payload ? payload.toLowerCase() : `${window.vehicleType}-${window.vin}`;
      document.cookie = `unLockPriceCookie-${payload}=${window.tid};path=/;expires=${cookieExpiryDate}`;
      state.unlockEPriceCookieVin = false;
    },
    [actiontypes.SET_UNLOCK_CASH_PRICE_DISCOUNT](state, vin) {
      let cookieExpiryDate = new Date(new Date().getTime() + 30 * 24 * 60 * 60 * 1000);
      document.cookie = `unLockCashPriceDiscount-${vin.toLowerCase()}=${
        window.tid
      };path=/;expires=${cookieExpiryDate}`;
      document.cookie = `unLockedCashPriceDiscount=${true};path=/;expires=${cookieExpiryDate}`;
      state.unlockCashPriceDiscount = false;
    },
    [actiontypes.SET_TRANSACT_UNLOCK_FORM_MODAL](state, payload) {
      state.transactUnlockFormModal = payload;
    },
    [actiontypes.SHOW_VDP_CONTACT_US](state, payload) {
      state.showVdpContactUS = payload;
    },
    [actiontypes.SET_FORM_HEADING](state, payload) {
      state.formHeading = payload;
    },
    [actiontypes.SET_FORM_BUTTON_LABEL](state, payload) {
      state.formButtonLabel = payload;
    },
    [actiontypes.SET_FORM_ACTION_NAME](state, payload) {
      state.formActionName = payload;
    },
    [actiontypes.SET_FORM_BUTTON_COLOR](state, payload) {
      state.formButtonColor = payload;
    },
    [actiontypes.SET_FORM_BUTTON_FONT_COLOR](state, payload) {
      state.formButtonFontColor = payload;
    },

    [actiontypes.VDP_TEXT_ME_QUOTE_FROM_PAYMENT_PANEL](state, payload) {
      state.showTextMeQuote = payload;
      state.showRequestVideo = false;
      state.vdpContactFromPaymentPanel = false;
      state.vdpContactFromTransact = false;
    },
    [actiontypes.REQUEST_VIDEO](state, payload) {
      state.showRequestVideo = payload;
      state.showTextMeQuote = false;
      state.vdpContactFromPaymentPanel = false;
      state.vdpContactFromTransact = false;
    },
    [actiontypes.SHOW_VDP_CONTACT_US_ZINDEX](state, payload) {
      state.vdpContactUsZindex = payload;
    },
    [actiontypes.VDP_CONTACT_FROM_TRANSACT](state, payload) {
      state.vdpContactFromTransact = payload;
      state.vdpContactFromPaymentPanel = false;
      state.showRequestVideo = false;
      state.showTextMeQuote = false;
    },
    [actiontypes.VDP_CONTACT_FROM_PAYMENT_PANEL](state, payload) {
      state.vdpContactFromPaymentPanel = payload;
      state.showRequestVideo = false;
      state.showTextMeQuote = false;
      state.vdpContactFromTransact = false;
    },
    [actiontypes.SET_LOCKINPAYMENT_TYPE](state, payload) {
      state.lockInPaymentType = payload;
    },
    [actiontypes.CASH_PRICE_DISCOUNT](state, payload) {
      state.cashPriceDiscountValue = payload;
    },
    setCompletePaymentsData(state, payload) {
      state.completePaymentsData = payload;
    },
    [actiontypes.SET_IS_TRANSACT](state, payload) {
      state.isTransact = payload;
    },
    [actiontypes.SET_SMARTPATH_UNLOCK_SETTINGS](state, payload) {
      state.smartPathUnlockStatus = payload;
    },
    [actiontypes.SET_SOFT_PULL_VEHICLE_PRICE](state, payload) {
      state.softPullVehiclePrice = payload;
    },
    [actiontypes.SET_SOFT_PULL_SETTINGS](state, payload) {
      state.getSoftPullSettings = payload;
    },
    [actiontypes.SET_STANDARD_FINANCE_VEHICLE_DATA](state, payload) {
      state.standardFinanceVehicleData = payload;
    },
    [actiontypes.SET_PAYMENT_CALCULATOR_INTERACTION_STATUS](state, payload) {
      state.paymentCalculatorInteractionCount = payload;
    },
    [actiontypes.SET_SEND_TO_PHONE_VDV](state, payload) {
      state.sendToPhoneVdv = payload;
    },
    [actiontypes.SET_PRE_QUAL_MODEL](state, payload) {
      state.showPreQualModel = payload;
    },

    UPDATE_ALTERNATE_PAYMENT(state, { key, label, value }) {
      state.alternatePayments[key]['label'] = label;
      state.alternatePayments[key]['value'] = value;
    },
    setUnlockCtaDiscountData(state, payload) {
      state.unlockCtaDiscountData = payload;
    },
  },
  actions: {
    async [actiontypes.GET_PAYMENT_SETTINGS](context, payload) {
      context.commit('getpaymentsettings', payload);
      context.commit(actiontypes.PAYMENT_SETTINGS_SUCCESS);

      let finalPriceValue = context.state.settings.yourPrice;

      if (context.state.isVehicleDetailsPage) {
        let shiftDigital = ShiftDigitalContainer.getShiftDigitalObject();
        window.displayedFinalPrice = Payments.conventStringToNumber(finalPriceValue);
        if (shiftDigital && typeof shiftDigital.vehicleDetailsPageView === 'function') {
          shiftDigital.vehicleDetailsPageView(
            window.vin,
            Payments.conventStringToNumber(finalPriceValue)
          );
        }
      }
      Payments.getPayments(0, 0, '', 0, '', 0, 0).then(async (response) => {
        context.commit(actiontypes.SET_LOADING, false);

        context.commit('setCompletePaymentsData', response.PaymentCollection);

        let leasefinancedata = Payments.formatPayments(response, '', payload);

        let leaseArray = Payments.extractLeaseData(response);
        let leaseFinanceTerms = Payments.getLeaseFinanceTerms(response);

        context.commit('setLeaseTerms', leaseFinanceTerms.leaseTerms);
        context.commit('setFinanceTerms', leaseFinanceTerms.financeTerms);

        context.commit('setTotalLeaseData', leaseArray);

        let leaseData = '';
        let financeData = '';

        let paymentsMessage = response.Message.toLowerCase();
        if (response?.PaymentCollection?.length) {
          context.commit(actiontypes.SET_FINANCE_TAB, true);
          context.commit(actiontypes.SET_LEASETAB, true);
        }

        let feesResults = await Payments.getFeesResults();
        if (feesResults) {
          context.commit(actiontypes.SET_PAYMENT_FEES_RESULTS, feesResults);
        }

        if (paymentsMessage !== '') {
          context.commit(actiontypes.SET_FINANCE_TAB, false);
          context.commit(actiontypes.SET_LEASETAB, false);
          context.commit(actiontypes.SET_SELECTEDPAYMENTOPTION, constants.CASH);
          context.commit('setpaymentsgot', true);
          return;
        }

        try {
          context.commit('setPaymentsFeesData', response.FeesAndTaxesCollection);
        } catch (e) {
          console.log(e);
        }

        if (leasefinancedata.length) {
          context.commit('getleasedata', leasefinancedata[0][0]);
          context.commit('getfinancedata', leasefinancedata[1][0]);

          if (leasefinancedata[0][0]) {
            context.commit(actiontypes.PAYMENT_SET_PREVIOUS_SELECTED_VALUES, {
              type: 'lease',
              values: {
                selectedPayment: 'lease',
                mileage: Payments.conventStringToNumber(leasefinancedata[0][0].MileageAllowance),
                downPayment: Payments.conventStringToNumber(leasefinancedata[0][0].Downpayment),
                tradeValue: 0,
                term: leasefinancedata[0][0].Term,
              },
            });
          }

          if (leasefinancedata[1][0]) {
            context.commit(actiontypes.PAYMENT_SET_PREVIOUS_SELECTED_VALUES, {
              type: 'finance',
              values: {
                selectedPayment: 'finance',
                downPayment: Payments.conventStringToNumber(leasefinancedata[1][0].Downpayment),
                tradeValue: 0,
                term: leasefinancedata[1][0].Term,
              },
            });
          }

          let isUsedVehicle = Payments.isUsedVehicle(payload);

          if (!isUsedVehicle) {
            if (Payments.isNewVehicleLeaseWindowAvailable()) {
              leaseData = leasefinancedata[0][0];
            }

            if (Payments.isNewVehicleFinanceWindowAvailable()) {
              financeData = leasefinancedata[1][0];
            }
          } else if (Payments.isUsedVehicleFinanceWindowAvailable()) {
            financeData = leasefinancedata[1][0];
          } else {
            //No action needed for other cases
          }

          context.commit(actiontypes.TRANSACT_POPUP_SHOW_TRANSACT, true);
        }

        context.commit(actiontypes.SET_LEASETAB, Payments.isLeaseTabVisible(payload));

        if (!context.state.settings.isLeasePaymentsActive) {
          context.commit(actiontypes.SET_LEASETAB, false);
        }

        if (!context.state.settings.isFinancePaymentsActive) {
          context.commit(actiontypes.SET_FINANCE_TAB, false);
        }

        let isUsedVehicle = Payments.isUsedVehicle(payload);

        if (!isUsedVehicle) {
          if (!Payments.isNewVehicleLeaseWindowAvailable()) {
            context.commit(actiontypes.SET_LEASETAB, false);
          }

          if (!Payments.isNewVehicleFinanceWindowAvailable()) {
            context.commit(actiontypes.SET_FINANCE_TAB, false);
          }
        } else if (!Payments.isUsedVehicleFinanceWindowAvailable()) {
          context.commit(actiontypes.SET_FINANCE_TAB, false);
        } else {
          //No action needed for other cases
        }

        if (!leasefinancedata[0][0]) {
          context.commit(actiontypes.SET_LEASETAB, false);
        }

        if (!leasefinancedata[1][0]) {
          context.commit(actiontypes.SET_FINANCE_TAB, false);
        }

        if (window.pageStateKey) {
          context.commit(actiontypes.SET_PAGESTATE_KEY, window.pageStateKey);
          context.commit(actiontypes.SET_LOADING, true);
          context.dispatch(actiontypes.GET_PAGESTATE_DATA, {
            paymentsettings: payload,
          });
        } else {
          let selectedOption = Payments.getSelectedPaymentOption(payload, leaseData, financeData);
          context.commit(actiontypes.SET_SELECTEDPAYMENTOPTION, selectedOption);
        }

        if (
          Payments.checkAudiPaymentDiscountLimits(context.state.settings, leasefinancedata[1][0])
        ) {
          context.commit(actiontypes.SET_FINANCE_TAB, false);
          context.commit(actiontypes.SET_LEASETAB, false);
          context.commit(actiontypes.SET_SELECTEDPAYMENTOPTION, constants.CASH.toLowerCase());
        }

        adminDefaultPaymentSelectionSettings(leaseData, financeData);

        context.commit('setpaymentsgot', true);
      });
    },

    [actiontypes.SET_PAYMENT_SETTINGS](context, payload) {
      let styleid = window.styleId;
      let vin = window.vin;
      if (vin) {
        styleid = '';
      }

      let accountId = window.vdpAccountId ? window.vdpAccountId : window.accountId;

      axios
        .get(
          `${window.ApiBaseUrl}/Inventory/getPaymentSettingDetails?accountId=${accountId}&vin=${vin}&styleid=${styleid}`
        )
        .then((response) => {
          context.dispatch(actiontypes.GET_PAYMENT_SETTINGS, response.data);
        });
    },

    [actiontypes.GET_MILES_DATA](context, payload) {
      const accountId = window.vdpAccountId ? window.vdpAccountId : window.accountId;
      axios
        .get(
          `${atob(
            window.portalUrl
          )}/OfferManager/service/OffermanagerApi/offerlogix/MileageAllowance/AccountID/${accountId}`
        )
        .then((response) => {
          context.commit(actiontypes.SET_MILES_DATA, response.data);
        });
    },
    [actiontypes.GET_PAGESTATE_DATA](context, payload) {
      axios
        .get(`${window.ApiBaseUrl}/PageState/get?pageKey=${window.pageStateKey}`)
        .then((response) => {
          context.commit(actiontypes.SET_LOADING, false);
          if (response.data) {
            context.commit(
              actiontypes.SET_PAYMENT_CONFIGURATION_DATA,
              response.data.paymentCalculator
            );
            context.commit(actiontypes.SET_SELECTEDPAYMENTOPTION, '');
            if (response.data.paymentCalculator.selectedPayment === constants.CASH) {
              context.commit(actiontypes.SET_SELECTEDPAYMENTOPTION, constants.CASH);
              context.commit(
                actiontypes.SET_CASH_TRADE_VALUE,
                response.data.paymentCalculator.tradeValue
              );
            } else {
              context.dispatch(actiontypes.GET_CUSTOMIZED_PAYMENTS, {
                paymentsdata: response.data.paymentCalculator,
                paymentsettings: payload,
              });
            }
          }
        });
    },
    [actiontypes.GET_CUSTOMIZED_PAYMENTS](context, payload) {
      context.commit(actiontypes.SET_LOADING, true);
      Payments.getPayments(
        1,
        payload.paymentsdata.downPayment,
        payload.paymentsdata.selectedPayment,
        payload.paymentsdata.term,
        payload.paymentsdata.mileage,
        payload.paymentsdata.tradeValue,
        0
      ).then((response) => {
        context.commit(actiontypes.SET_LOADING, false);
        context.commit('setpaymentsgot', true);
        let data = Payments.filterPaymentsByTerm(response, payload.paymentsdata.term);

        if (constants.LEASE.toLowerCase() === payload.paymentsdata.selectedPayment.toLowerCase()) {
          context.commit(actiontypes.SET_SELECTEDPAYMENTOPTION, constants.LEASE);
          if (data) {
            context.commit(actiontypes.SET_LEASE_DATA, data);
          }
        } else if (
          constants.FINANCE.toLowerCase() === payload.paymentsdata.selectedPayment.toLowerCase()
        ) {
          context.commit(actiontypes.SET_SELECTEDPAYMENTOPTION, constants.FINANCE);
          if (data) {
            context.commit(actiontypes.SET_FINANCE_DATA, data);
          }
        } else {
          // No action needed for other cases.
        }
      });
    },
    [actiontypes.GET_SMARTPATH_UNLOCK_SETTINGS](context, payload) {
      if (window.enableUnlockSmartPrice) {
        SmartPathService.smartPathUnlockStatus()
          .then((res) => {
            if (res?.data?.length && res?.data?.includes(window.oemCode)) {
              context.commit(actiontypes.SET_SMARTPATH_UNLOCK_SETTINGS, true);
            } else {
              context.commit(actiontypes.SET_SMARTPATH_UNLOCK_SETTINGS, false);
            }
          })
          .catch((e) => {
            context.commit(actiontypes.SET_SMARTPATH_UNLOCK_SETTINGS, false);
          });
      } else {
        context.commit(actiontypes.SET_SMARTPATH_UNLOCK_SETTINGS, true);
      }
    },
    [actiontypes.GET_ALL_FORD_DIRECT_QUALIFIED_INCENTIVES](context, payload) {
      context.commit('getFordDirectQualifiedIncentives', payload);
    },
    [actiontypes.SET_CONDITIONAL_REBATE_INCENTIVES](context, payload) {
      context.commit('setConditionalRebateIncentives', payload);
    },
    [actiontypes.REBATE_LABEL](context, payload) {
      context.commit('getRebateLabel', payload);
    },
    [actiontypes.DISCOUNT_LABEL](context, payload) {
      context.commit('getDiscountLabel', payload);
    },
    [actiontypes.FINAL_PRICE_LABEL](context, payload) {
      context.commit('getFinalPriceLabel', payload);
    },
    [actiontypes.SET_AIS_REBATES](context, payload) {
      context.commit('setAisRebates', payload);
    },
    updateAlternatePayment(context, payload) {
      context.commit('UPDATE_ALTERNATE_PAYMENT', payload);
    },
  },
};
